import React, { useState } from 'react';
import * as Yup from 'yup';
import {
    CrudMasterDetailView,
    GridView,
    Widget,
    FormInput,
    FormSubmitButton,
    CompositeView,
    MasterDetailForm,
    FormatText,
    ButtonDelete,
    CrudContext,
} from '@digital/ui';
import { hasPermission } from '../../helpers/permissions';
import TabelaPermissaoPerfil from './tabelaPermissaoPerfil';
import { GuidEmpty } from '@app/helpers/generatorGuid';
import { creatTipoModulo, CreatTipoModulo, getAllTipoModulo, updateTipoModulo } from '@app/api/tipoModulo';
import { useEffect } from 'react';


const DefinicaoTipoModulo = () => {

    const [listDefinicaoTipoModulo, setlistDefinicaoTipoModulo] = useState(() => getAllTipoModulo);

    const onCreat = (values: CreatTipoModulo) => {
        return creatTipoModulo(values);
    }

    const onUpdate = (values: CreatTipoModulo) => {
        return updateTipoModulo(values.id, values);
    }

    const validationSchema = Yup.object().shape({
        nome: Yup.string().required('Nome deve ser informada'),
    });




    return (
        <CrudMasterDetailView
            getAllItems={listDefinicaoTipoModulo}
            createItem={true ? onCreat : undefined}
            updateItem={true ? onUpdate : undefined}
            disableNotification
            icon="business-flow_chart"
            detailTitleExtractor={x => `${x.codigo} - ${x.nome}`}
            filterPredicate={(item, value) =>
                item.nome.toLowerCase().includes(value.toLowerCase())
            }
            titleExtractor={item => item.nome}
            descriptionExtractor={item => item.codigo || `--- - ${item.nome}`}>
            <CompositeView>
                {true && (
                    <CrudContext.Consumer>
                        {({ selectedItem }) => {
                            return (
                                <GridView noform>
                                    <MasterDetailForm
                                        validationSchema={validationSchema}>
                                        <Widget
                                            actions={[
                                                (
                                                    <FormSubmitButton type="primary">
                                                        <FormatText id="ui.commons.save" uppercase />
                                                    </FormSubmitButton>
                                                ),
                                            ]}>
                                            <FormInput label="Nome" name="nome" span={6} />
                                        </Widget>
                                    </MasterDetailForm>
                                </GridView>
                            );
                        }}
                    </CrudContext.Consumer>
                )}
            </CompositeView>
        </CrudMasterDetailView>
    )

}

export default DefinicaoTipoModulo;